import React from 'react';

// Workflow state only: DS keeps green/amber/rose for clinical signals.
const TONES = {
  neutral: 'bg-gray-200 text-gray-700',
  brand: 'bg-blue-100 text-blue-800',
};

/** DS status pill: dot + label, sentence case. */
const StatusBadge = ({ tone = 'neutral', className = '', children }) => (
  <span className={`inline-flex items-center gap-ds-1 whitespace-nowrap rounded-ds-pill px-ds-2 py-ds-1 text-ts-xs font-semibold ${TONES[tone] || TONES.neutral} ${className}`.trim()}>
    <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
    {children}
  </span>
);

export default StatusBadge;
